module.exports = __webpack_public_path__ + "static/media/Solar.575d5190.svg";